
export const GET_PATIENTINFORMATION_REQUEST = "GET_PATIENTINFORMATION_REQUEST";
export const GET_PATIENTINFORMATION_SUCCESS = "GET_PATIENTINFORMATION_SUCCESS";
export const GET_PATIENTINFORMATION_FALIURE = "GET_PATIENTINFORMATION_FALIURE";

export const GET_PATIENTVITAL_REQUEST = "GET_PATIENTVITAL_REQUEST";
export const GET_PATIENTVITAL_SUCCESS = "GET_PATIENTVITAL_SUCCESS";
export const GET_PATIENTVITAL_FALIURE = "GET_PATIENTVITAL_FALIURE";